import { render, staticRenderFns } from "./SwitchCompanyWithFactory.vue?vue&type=template&id=1415faaa"
import script from "./SwitchCompanyWithFactory.vue?vue&type=script&lang=js"
export * from "./SwitchCompanyWithFactory.vue?vue&type=script&lang=js"
import style0 from "./SwitchCompanyWithFactory.vue?vue&type=style&index=0&id=1415faaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports